import { getClasses } from '../../utils/styler';
import './index.scss';

const Icon = ({ name, customClass, ...props }) => <img
	className={getClasses({ ...props }, 'icon', customClass)}
	alt=""
	src={require(`../../assets/images/${name}.svg`)}
/>;

export default Icon;
